export default "__VITE_ASSET__b675b2de__"